export default "__VITE_ASSET__oGnYqySv__"